import { getRequestHandler } from '../utils/utils';
import { BASE_CORE_URL, BASE_URL, UAPI_URL_ALERT, UAPI_URL_CCTV } from './../config/index'

//#region Api Calling for rassaAutoken
export const getrasaauthtoken = async (obj) => {
return null;
    let url = `${BASE_URL}getrasaauthtoken`

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api caling for ERT add to chatroom
export const adderttochatroom = async (obj) => {
return null ;
    let url = `${BASE_URL}adderttochatroom`

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api calling for ERT message
export const getertmessages = async (obj) => {
return null ;
    let url = `${BASE_URL}getertmessages`

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api calling for addrasaconversationdb 
export const addrasaconversationindb = async (obj) => {

    let url = `${UAPI_URL_ALERT}alerts/addrasaconversationindb`

    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
         },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling for conversationtemplate crud
export const conversationtemplatecrud = async (obj) => {
return null ;
    let url = `${BASE_URL}conversationtemplatecrud`

    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json', 
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
         },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling for conversationtemplate crud
export const conversationtemplatecrudGET = async (obj) => {

    // let url = `${BASE_URL}conversationtemplatecrud`
    let loggedInUser = JSON.parse(localStorage.getItem('user'))
    let { conversationId } = obj
    // let Tempurl = "http://127.0.0.1:8002/api/alerts/getAlertActivityLogs/?conversationId=7&rasaConversationId=AlertID_100_UserID_14&userId=40FB9380-2BE6-4242-98ED-D8484935913F"
    let url = UAPI_URL_ALERT + `alerts/getAlertActivityLogs/?rasaConversationId=${conversationId}&userId=${loggedInUser.Id}`

    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',             
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
        },
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling for conversationtemplate crud
export const conversationtemplatecrudADD = async (obj) => {
    let loggedInUser = JSON.parse(localStorage.getItem('user'))
    obj.userId = loggedInUser?.Id
    obj.organizationMasterId = loggedInUser?.OrganizationMasterID
    // let url = `${BASE_URL}conversationtemplatecrud`
    let url = `${UAPI_URL_ALERT}alerts/createAlertConversation/`

    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json', 
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
         },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling for conversationtemplate crud
export const conversationtemplatecrudHandleOpBot = async (obj) => {
    let loggedInUser = JSON.parse(localStorage.getItem('user'))
    obj.userId = loggedInUser?.Id
    obj.organizationMasterId = loggedInUser?.OrganizationMasterID
    // let url = `${BASE_URL}conversationtemplatecrud`
    let url = `${UAPI_URL_ALERT}alerts/handleOpBotCloseMessage`

    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',             
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
        },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api calling for update alert 
export const updatealert = async (obj) => {

    // let url = `${BASE_URL}updatealert`
    let url = `${UAPI_URL_ALERT}alerts/updateAlert/`

    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json', 
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
         },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api calling for add alert request
export const addalertrequest = async (obj) => {
return null ;
    let url = `${BASE_URL}addalertrequest`

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api calling for nearbyresource in chatflow (police,hospitals,fire station)
export const nearbyresource = async (obj) => {

    //let url = `${BASE_URL}nearbyresource`
    let url = `${UAPI_URL_ALERT}alerts/nearByResource/`

    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',             
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
        },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api calling to make a calling for Add user to site Make call part 
export const makecall = async (obj) => {
return null ;
    let url = `${BASE_URL}makecall`

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api calling for streamingurl 
export const getstreamingurl = async (obj) => {

    // let url = `${BASE_URL}getroverstreamingurl`
    let url = `${UAPI_URL_CCTV}getRoverStreamingUrl`
    let loggedInUser = JSON.parse(localStorage.getItem('user'))
    obj.userId =loggedInUser?.Id
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json', 
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
         },
        body: JSON.stringify(obj),
    };
    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api calling for sendemail 
export const sendemail = async (obj) => {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
    };
return null ;
    const url = BASE_URL + "sendemail";
    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error("sendemail response: ", error);
        });
}
//#endregion

//#region Api Calling for chatflow conversation
export const getRasaConversation = async (obj) => {
    let url = `${BASE_URL}getRasaConversation`
    return null;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling for send mail while closing the alert
export const sendEmailAlertClose = async (alertId) => {
    
    const requestOptions = {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
    };
    
    let url = `${BASE_CORE_URL}Notification/SendEmail?alertId=${alertId}`
    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling for chatflow conversation
export const addReasonToAlert = async (obj) => {
    let url = `${BASE_URL}addReasonToAlert`
return null ;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

export const alertReassign = async (userId, alertId, reassignTo, rasaConversationId) => {
      let url = UAPI_URL_ALERT + `alerts/alertReassign?userId=${userId}&alertId=${alertId}&reassignTo=${reassignTo}&rasaConversationId=${rasaConversationId}`
      return getRequestHandler(url);
}

export const getAlertMapDetails = async (userId, deviceId) => {
    let url = UAPI_URL_ALERT + `alerts/alertMapDetails?userId=${userId}&deviceId=${deviceId}`
    return getRequestHandler(url);
}